import { PageBillingType } from '@mm/state/interfaces/connected-page';
import React, { ReactNode, useState } from 'react';
import { ProRibbonType } from '../ProRibbon/ProRibbon';
import './CollapsibleContentContainer.pcss';
import { CollapsibleContentContainerWithoutLocalState } from './CollapsibleContentContainerWithoutLocalState';

export type StepperStylingPlatform =
  | 'facebook'
  | 'facebook-inverted'
  | 'instagram'
  | 'sms'
  | 'webchat'
  | 'native_integrations'
  | 'mailchimp'
  | 'webhooks'
  | 'sold'
  | 'xray';

export type Props = {
  orderNumber?: string;
  containerName: string | ReactNode;
  expandedOnMount?: boolean;
  disableExpand?: boolean;
  proRibbonType?: ProRibbonType;
  proBadgeType?: PageBillingType;
  onClickOverride?: (e: any) => any;
  className?: string;
  headerClassName?: string;
  childrenContainerClassName?: string;
  dropdownMenuContent?: JSX.Element;
  onDropdownMenuChange?: (isDropdownActive: boolean) => any;
  useCrossIconStyle?: boolean;
  isProcessed?: boolean;
  children?: ReactNode;
  useCircleNumberStyle?: boolean;
  stepperStylingPlatform?: StepperStylingPlatform;
  hideExpandIcon?: boolean;
  hideTitleBorder?: boolean;
};

const CollapsibleContentContainer = (props: Props) => {
  const { expandedOnMount = true } = props;
  const [isExpanded, toggleIsExpanded] = useState(expandedOnMount);

  return (
    <CollapsibleContentContainerWithoutLocalState
      isExpanded={isExpanded}
      toggleIsExpanded={toggleIsExpanded}
      {...props}
    />
  );
};

export default CollapsibleContentContainer;
